import React from 'react';
import './Hero.css';

function Hero() {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className="hero">
            <div className="hero-badge fade-up">
                <span className="hero-badge-dot"></span>
                Разработка и интеграция приложений
            </div>

            <h1 className="hero-title" aria-label="Технологии для бизнеса и образования">
                <span className="hero-title-line">
                    <span className="hero-title-word hero-title-word--1">Технологии</span>{' '}
                    <span className="hero-title-word hero-title-word--2">для</span>{' '}
                    <span className="hero-title-word hero-title-highlight hero-title-word--3">бизнеса</span>
                </span>
                <span className="hero-title-line">
                    <span className="hero-title-word hero-title-word--4">и</span>{' '}
                    <span className="hero-title-word hero-title-word--5">образования</span>
                </span>
            </h1>

            <p className="hero-sub hero-sub--reveal">
                Разрабатываем и интегрируем веб и десктоп приложения под реальные задачи — от автоматизации процессов до современных образовательных платформ.
            </p>

            <div className="hero-actions hero-actions--reveal">
                <a href="#services" className="btn btn-accent" onClick={(e) => handleNavClick(e, '#services')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                    Наши услуги
                </a>
                <a href="mailto:support@aicoll.ru" className="btn btn-ghost">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                    Связаться с нами
                </a>
            </div>
        </section>
    );
}

export default Hero;
